import styled, { css } from 'styled-components';

import { Icon } from 'ui/components/shared';
import { spacing, positioning } from 'ui/theme/utils';

const disabledOpacity = 0.5;

export const IconButton = styled.button.attrs(
  ({ variant, icon, iconProps = {}, src, alt, size, type = 'button' }) => {
    switch (variant) {
      case 'rounded':
        iconProps.size = iconProps.size || '20px';
        break;
      case 'transparent':
        iconProps.size = iconProps.size || '100%';
        break;
      default:
        break;
    }

    switch (icon) {
      case 'plus':
      case 'plus-white':
        iconProps.size = iconProps.size || '14px';
        break;
      case 'maximize':
      case 'minimize':
        iconProps.size = iconProps.size || '20px';
        break;
      case 'trash':
        size = size || '22px';
        break;
      case 'unlink':
        size = size || '18px';
        break;
      default:
        break;
    }

    return {
      children: <Icon icon={icon} src={src} alt={alt} {...iconProps} />,
      size,
      type,
    };
  }
)`
  position: relative;
  border: none;
  padding: 0;
  overflow: hidden;
  transition: all 300ms ease-in-out;
  opacity: ${({ opacity = 1 }) => opacity};
  &:hover {
    opacity: ${({ opacityOnHover = 0.9, disabled }) =>
      disabled ? disabledOpacity : opacityOnHover};
    ${({ bgOnHover }) => bgOnHover && `background-color: ${bgOnHover};`}
  }
  > img,
  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  ${({ variant }) => {
    switch (variant) {
      case 'rounded':
        return css`
          width: ${({ width = '50px', size }) => size || width};
          height: ${({ height = '50px', size }) => size || height};
          border-radius: 50%;
          background-color: ${({ theme, bg = 'primary' }) => theme.colors[bg] || bg};
          filter: ${({ filter = 'drop-shadow(0px 3px 10px rgba(0, 0, 0, 0.16))' }) => filter};
        `;
      case 'transparent':
        return css`
          background-color: transparent;
          width: ${({ width = '20px', size }) => size || width};
          height: ${({ height = '20px', size }) => size || height};
          ${({ padding }) => padding && `padding: ${padding};`}
        `;
      default:
        return css`
          width: ${({ width = '34px', size }) => size || width};
          height: ${({ height = '34px', size }) => size || height};
          border-radius: ${({ borderRadius = '2px' }) => borderRadius};
          ${({ boxShadow, theme }) =>
            boxShadow && `box-shadow: ${theme.shadows[boxShadow] || boxShadow};`}
          background-color: ${({ theme, bg = '#e6eeff' }) => theme.colors[bg] || bg};
        `;
    }
  }}
  ${({ disabled }) =>
    disabled &&
    css`
    opacity: ${disabledOpacity};
    cursor: ${({ disabledCursor = 'not-allowed' }) => disabledCursor};
  `}
  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}
`;
